import React, { useState, useEffect, useContext } from 'react';
import UserContext from '../../components/User_Context.js';
import { useParams } from 'react-router-dom';
import * as menu from "../../assets/menus/menu.js"
import waiting from "../../assets/images/waiting.svg";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import * as utils from "../../components/utils.js";
import abstractBackground from '../../assets/images/activityImage/abstract-background.jpg'
import * as api from "../../api/apiConnector.js";
import * as labels from "../../components/localized/labels.js";
import ActivityUserLink from '../../components/activity_user_link.js';
import { useTranslation } from 'react-i18next';
import { ActivitiesLabels } from '../_label/activities/activities_labels.js';

const ActivityList_Screen = (params) => {
    const { t } = useTranslation();

    const [activityList, setActivityList] = useState(null);
    const [preferredActivityList, setPreferredActivityList] = useState(null);

    const [board, setBoard] = useState(null);
    const [currentTask, setCurrentTask] = useState(null);
    const { id } = useParams();

    const { currentUser } = useContext(UserContext);
    const [currentList, setCurrentList] = useState(null);

    const [draggingNode, setDraggingNode] = useState(null);
    const [droppingNode, setDroppingNode] = useState(null);
    const [droppingPosition, setDroppingPosition] = useState(null);
    const [dragEnabledCards, setDragEnabledCards] = useState(new Set());


    useEffect(() => {

        (async () => {
            // Initialize i18n labels from centralized file
            const i18n = menu.getI18n();
            i18n.addResourceBundle('it', 'labels', ActivitiesLabels.it, true, true);
            i18n.addResourceBundle('en', 'labels', ActivitiesLabels.en, true, true);
            
            setBreadCrumb();
            menu.write({ user: currentUser() });
            await retrieveData();

        })();
    }, []);

    useEffect(() => {
        (async () => {
        if (activityList && preferredActivityList) {

            for (let index = 0; index < activityList.length; index++) {
                const list = activityList[index];
                if (list.Order != index) {
                    list.Order = index;
                    await saveOrderAndPreferred(list);
                }
            }

            for (let index = 0; index < preferredActivityList.length; index++) {
                const preferredlist = preferredActivityList[index];
                if (preferredlist.Order != index) {
                    preferredlist.Order = index;
                    await saveOrderAndPreferred(preferredlist);
                }
            }
            _drawActivityList();




            const _drawHelperDraggable = (element) => {

                const titleListElement = element.find('[data-property="titleList"]');
                const titleListText = titleListElement.text();


                const originalElement = element;
                const originalWidth = originalElement.outerWidth();
                const originalHeight = originalElement.outerHeight();

                const copyDiv = window.$(`<div class="copy-board-card" style="width:${originalWidth},">
                            <div class="copy-board-card-header">
                              <h5>${titleListText} </h5>
                            </div>
                          
                            
                        </div>
                       
                        </div>`);

                copyDiv.width(originalWidth);
                copyDiv.height(originalHeight);
                window.$(copyDiv).css("z-index", 1000);

                return (copyDiv);

            }

            const _drawStartDraggable = (e, ui) => {
                window.$(e.target).css("z-index", 1000);

                window.$(e.target).css("z-index", 1000);


                let draggingNode = activityList.find(x => x.Id == window.$(e.target).attr("data-id"));

                if (draggingNode == null) {
                    draggingNode = preferredActivityList.find(x => x.Id == window.$(e.target).attr("data-id"));
                }
                setDraggingNode(draggingNode);

            }


            window.$("div[data-list-type='preferred']").draggable({
                opacity: 0.9,
                cursor: "move",
                containment: window.$(`div[data-root-node='preferred']`),
                revert: "invalid",
                helper: function (event) {
                    return _drawHelperDraggable(window.$(this));
                },
                start: (e, ui) => {
                    _drawStartDraggable(e, ui);
                    window.$(e.target).css('cursor', 'grabbing');

                },
                drag: (e, ui) => {

                },

                stop: (e) => {
                    window.$(e.target).css("z-index", 0);
                    window.$(e.target).css('cursor', 'grab');
                    // Don't reset here - let the useEffect handle all resets

                },
            })


            window.$("div[data-list-type='normal']").draggable({
                opacity: 0.9,
                cursor: "move",
                containment: window.$(`div[data-root-node='normal']`),
                revert: "invalid",
                helper: function (event) {
                    return _drawHelperDraggable(window.$(this));
                },
                start: (e, ui) => {
                    _drawStartDraggable(e, ui);
                    window.$(e.target).css('cursor', 'grabbing');

                },
                drag: (e, ui) => {

                },

                stop: (e) => {
                    window.$(e.target).css("z-index", 0);
                    window.$(e.target).css('cursor', 'grab');
                    // Don't reset here - let the useEffect handle all resets

                },
            })





            window.$("div[data-id]").droppable({
                over: (e, ui) => {
                },
                out: (e, ui) => {
                    
                },
                drop: (e, ui) => {
                    let dropNode = activityList.find(x => x.Id == window.$(e.target).attr("data-id"));

                    if (dropNode == null) {
                        dropNode = preferredActivityList.find(x => x.Id == window.$(e.target).attr("data-id"));
                    }
                    
                    // Don't allow dropping on the same element
                    const draggedId = ui.draggable.attr("data-id");
                    if (dropNode && dropNode.Id == draggedId) {
                        return;
                    }
                    
                    console.log('Setting dropping node:', dropNode?.Name, 'ID:', dropNode?.Id);
                    setDroppingNode(dropNode);

                    // Calculate drop position based on mouse position relative to the card center
                    const cardElement = window.$(e.target).closest('[data-id]');
                    const cardOffset = cardElement.offset();
                    const cardWidth = cardElement.outerWidth();
                    
                    // Use the actual mouse position at drop time
                    const mouseX = e.pageX || (e.originalEvent && e.originalEvent.pageX) || ui.position.left + ui.draggable.outerWidth()/2;
                    const cardCenterX = cardOffset.left + (cardWidth / 2);
                    
                    const dropPosition = mouseX < cardCenterX ? 'left' : 'right';
                    
                    console.log('Drop Debug:', {
                        draggedId,
                        dropNodeId: dropNode?.Id,
                        mouseX,
                        cardCenterX,
                        cardOffset: cardOffset.left,
                        cardWidth,
                        dropPosition
                    });
                    
                    setDroppingPosition(dropPosition);
                    ui.draggable.css('transform', '');
                }
            });
            window.$("div[data-root-node]").droppable({
                drop: (e, ui) => {
                    //setDroppingNode({ Id: null });
                    //ui.draggable.animate({ left: 0, top: 0 }, 250);
                    ui.draggable.css('transform', '');

                }
            });



        }
        })();
    }, [activityList, preferredActivityList, dragEnabledCards]);


    useEffect(() => {
        if (draggingNode && droppingNode && droppingPosition) {
            
            console.log('Processing reorder operation...');

            const originalList = draggingNode.Preferred ? preferredActivityList : activityList;
            
            // CREATE A COPY FIRST - DON'T MUTATE ORIGINAL STATE
            const listToChange = utils.clone(originalList);

            // Find indices BEFORE removing the dragged item
            const draggedIndex = listToChange.findIndex(x => x.Id == draggingNode.Id);
            const droppingIndex = listToChange.findIndex(board => board.Id === droppingNode.Id);

            console.log('Reorder Debug:', {
                draggingNodeId: draggingNode.Id,
                draggingNodeName: draggingNode.Name,
                droppingNodeId: droppingNode.Id,
                droppingNodeName: droppingNode.Name,
                droppingPosition,
                draggedIndex,
                droppingIndex,
                listLength: listToChange.length,
                listNames: listToChange.map(x => x.Name)
            });

            // Calculate final position
            let finalPosition;
            switch (droppingPosition) {
                case "left":
                    finalPosition = droppingIndex;
                    break;
                case "right":
                    finalPosition = droppingIndex + 1;
                    break;
                default:
                    finalPosition = droppingIndex;
                    break;
            }

            // FIXED: Adjust final position if dragged item is before the final position
            // When we remove an item, indices shift, so we need to account for that
            if (draggedIndex < finalPosition) {
                finalPosition = finalPosition - 1;
            }

            console.log('Final position calculated:', finalPosition);

            // Remove the dragged item
            listToChange.splice(draggedIndex, 1);

            // Insert at correct position
            listToChange.splice(finalPosition, 0, { ...draggingNode });

            // UPDATE ORDER PROPERTIES TO MATCH NEW POSITIONS
            listToChange.forEach((item, index) => {
                item.Order = index;
            });

            console.log('After reorder:', listToChange.map(x => x.Name));
            console.log('Updated Orders:', listToChange.map(x => ({ name: x.Name, order: x.Order })));

            // Update state with the new array
            if (draggingNode.Preferred) {
                setPreferredActivityList(listToChange);
            }
            else {
                setActivityList(listToChange);
            }

            // Simple immediate reset
            setDraggingNode(null);
            setDroppingNode(null);
            setDroppingPosition(null);
            setDragEnabledCards(new Set());






        }

    }, [droppingNode, draggingNode, droppingPosition]);







    useEffect(() => {
        setBreadCrumb();
    }, [board]);


    const saveOrderAndPreferred = async (list) => {

        const list_result = await api.sendMessage("activity/list/saveListOrderAndPreferred", {
            user: currentUser(),
            body: {
                list: list
            }
        })
    }

    const setBreadCrumb = (params) => {
        var path = [{
            link: "/",
            name: t('home', { ns: 'labels' })
        },
        {
            link: "/activity/board",
            name: t('yourBoards', { ns: 'labels' })
        },
        {
            link: `/activity/activityList/${id}`,
            name: board?.Name ?? t('activityList', { ns: 'labels' })
        }
        ];
        breadcrumb.set(path);
    }


    const retrieveData = async () => {

        var board_result = await api.sendMessage("activity/board/getBoards", {
            user: currentUser(),
            body: {
                boardId: id
            }

        });

        setBoard(board_result.boards[0]);

        var result = await api.sendMessage("activity/list/getActivityList", {
            user: currentUser(),
            body: {
                boardId: id
            }
        });


        for (var al of result.activityLists) {
            if (al.Tasks.length > 0) {
                al.Tasks.sort((a, b) => {
                    return (
                        new Date(a.StartDate) - new Date(b.StartDate) ||
                        new Date(a.EndDate) - new Date(b.EndDate) ||
                        a.Progress - b.Progress);
                })

            }

        }




        const preferredActivityList = result.activityLists.filter(x => x.Preferred).sort((a, b) => { return (a.Order - b.Order || a.Name.localeCompare(b.Name)) });
        const activityList = result.activityLists.filter(x => !x.Preferred).sort((a, b) => { return (a.Order - b.Order || a.Name.localeCompare(b.Name)) });

        setActivityList(activityList);
        setPreferredActivityList(preferredActivityList);
    }



    const showDeleteActivityModal = (activity) => {
        withReactContent(Swal).fire({
            title: t('areYouSure', { ns: 'labels' }),
            icon: "warning",
            text: t('areYouSureDeleteList', { ns: 'labels', boardName: activity.Name }),
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: labels.getText()["YES"](),
            cancelButtonText: labels.getText()["NO"](),
            confirmButtonColor: "#DD6B55",


        }).then(async (result) => {
            if (result.isConfirmed) {
                deleteActivity(activity);
                withReactContent(Swal).close();

            }
        });
    }

    const deleteActivity = async (activityListToDelete) => {

        var delete_result = await api.sendMessage("activity/list/deleteActivityList", {
            user: currentUser(),
            body: { activityListId: activityListToDelete.Id }
        });


        if (delete_result.message) {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: delete_result.message,
                showConfirmButton: true
            });
        }
        else {
            withReactContent(Swal).fire({
                title: t('deleted', { ns: 'labels' }),
                icon: "success",
                text: t('listDeletedCorrectly', { ns: 'labels', boardName: delete_result.deleted_activity[0].Name }),
                showConfirmButton: true,
                timer: 1500
            });
            activityList.splice(activityList.findIndex(x => x.Id === activityListToDelete.Id), 1);
            setActivityList(utils.clone(activityList));
        }
    }

    const toggleDragMode = (listId) => {
        console.log('Toggle drag mode for card:', listId);
        setDragEnabledCards(prev => {
            const newSet = new Set(prev);
            if (newSet.has(listId)) {
                newSet.delete(listId);
            } else {
                newSet.add(listId);
            }
            return newSet;
        });
    };

    const changePreferred = async (list) => {

        const realListPreviousValue = list.Preferred;



        if (list.Preferred) {
            preferredActivityList.splice(preferredActivityList.findIndex(x => x.Id == list.Id), 1);
            list.Preferred = !realListPreviousValue;
            activityList.push(list);

        }
        else {
            activityList.splice(activityList.findIndex(x => x.Id == list.Id), 1);
            list.Preferred = !realListPreviousValue;
            preferredActivityList.push(list);
        }



        withReactContent(Swal).fire({
            title: t('info', { ns: 'labels' }),
            icon: "info",
            text: realListPreviousValue ? t('movingListToOther', { ns: 'labels', listName: list.Name }) : t('movingListToFavourite', { ns: 'labels', listName: list.Name }),
            showConfirmButton: true,
            timer: 1500
        });



        await saveOrderAndPreferred(list);

        setPreferredActivityList(utils.clone(preferredActivityList));
        setActivityList(utils.clone(activityList));

    }

    const _drawList = (list, type) => {
        return (
            <div className='row me-3'>
                <div 
                    className={`card col-md-12 activityCardGrey draggable-card ${dragEnabledCards.has(list.Id) ? 'drag-enabled' : ''}`}
                    data-id={list.Id} 
                    data-list-type={type} 
                    data-position="center"
                    data-drag-enabled={dragEnabledCards.has(list.Id) ? 'true' : 'false'}
                    style={{ 
                        cursor: dragEnabledCards.has(list.Id) ? 'grab' : 'pointer',
                        border: dragEnabledCards.has(list.Id) ? '2px dashed #007bff' : 'none',
                        opacity: dragEnabledCards.has(list.Id) ? 0.8 : 1
                    }}
                    onClick={(e) => {
                        // Prevent triggering when clicking on buttons or dropdowns
                        if (e.target.closest('.dropdown, .btn, button')) {
                            return;
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        toggleDragMode(list.Id);
                    }}
                >
                    
                    <div className="card-header">
                        <h5 className=" col" data-property="titleList">{list.Name}
                            <button className="btn btn-link col ms-3" style={{ padding: 0 }}
                                onClick={(e) => {
                                    changePreferred(list);
                                }}
                            >
                                <i className="fas fa-heart "
                                    style={{ color: (list.Preferred ? 'red' : 'lightblue'), borderColor: 'red' }} ></i>
                            </button>
                        </h5>
                        <div className="dropdown ms-auto text-end c-pointer threedot" data-bs-toggle="dropdown" aria-expanded="false">
                            <div className="btn-link threedotDiv" >
                                <i className="fas fa-ellipsis-v" style={{ marginRight: "0.9em" }}></i>
                            </div>
                            <div className="dropdown-menu dropdown-menu-end">
                                {/* edit menu */}
                                <button onClick={() => {
                                    setCurrentList(list);
                                }} className="dropdown-item"><i className="fas fa-pencil-alt me-2"></i>{t('edit', { ns: 'labels' })}</button>

                                {/* delete */}
                                <button onClick={() => {
                                    showDeleteActivityModal(list);
                                }} className="dropdown-item"><i className="fa fa-trash me-2"></i>{t('delete', { ns: 'labels' })}</button>
                            </div>
                        </div>
                    </div>

                    {list?.Tasks?.length > 0 ? (
                        list?.Tasks.map(x => {
                            return _drawTasks(x);
                        }))
                        : (null)}

                    {_drawNewTask(list.Id)}
                </div>
            </div>)
    }

    const _drawTasks = (task) => {
        return (<div class="card-body" onDoubleClick={(e) => {
            window.location.href = `/activity/task/${task.Id}`;


        }}>

            <div class="activityCardWhite">
                <div className='row'>

                    <p className="col">{task.Name}</p>

                    <div class="dropdown ms-auto text-end c-pointer threedot" data-bs-toggle="dropdown" aria-expanded="false">
                        <div class="btn-link threedotDiv" >
                            <i class="fas fa-ellipsis-v" style={{ marginRight: "0.9em" }}></i>
                        </div>
                        <div class="dropdown-menu dropdown-menu-end">

                            {/* edit menu */}

                            <button onClick={() => {
                                setCurrentTask(task);
                            }} class="dropdown-item"><i class="fas fa-pencil-alt me-2"></i>{t('edit', { ns: 'labels' })}</button>

                            {/* delete */}
                            <button onClick={() => {
                                showDeleteTaskModal(task);

                            }} class="dropdown-item"><i class="fa fa-trash me-2"></i>{t('delete', { ns: 'labels' })} </button>


                        </div>
                    </div>

                </div>

            </div>
        </div>)
    }

    const _drawNewTask = (listId) => {
        return (
            <div class="card-body"  >
                <div class="card-body activityCardWhite" style={{ cursor: 'pointer' }} onClick={() => {
                    var newTask = {
                        ActivityBoardListId: listId,
                        LinkedUsers: [currentUser()]
                    };

                    // activityList.push(newActivity);
                    // setActivityList(utils.clone(activityList));
                    setCurrentTask(newTask);

                }

                }>
                    <i class="fa-solid fa-plus fa me-2  ms-2"></i>{t('newTask', { ns: 'labels' })}
                </div>
            </div>

        )
    }

    const saveList = async (activityToSave) => {
        withReactContent(Swal).fire({
            title: t('info', { ns: 'labels' }),
            icon: "info",
            text: t('savingData', { ns: 'labels' }),
            showConfirmButton: true,
            timer: 4500
        });

        if (activityToSave.Name && activityToSave.Name != '') {

            var result = await api.sendMessage("activity/list/saveActivityList", {
                user: currentUser(),
                body: { activityToSave: activityToSave }
            });

            if ((result.activities.length + result.links.length) > 0) {

                for (const b of result.activities) {
                    const links = result.links.find(x => x.ActivityListId == b.Id);

                    // Preserve LinkedUsers from the form if not present in backend response
                    if (!b.LinkedUsers || b.LinkedUsers.length === 0) {
                        b.LinkedUsers = activityToSave.LinkedUsers || [];
                    }

                    // Determine the correct Preferred value
                    let finalPreferred;
                    if (links) {
                        finalPreferred = links.Preferred;
                    } else {
                        // Preserve the original Preferred value from the form
                        finalPreferred = activityToSave.Preferred;
                    }

                    // Remove from current lists based on original preferred status
                    if (activityToSave.Id) {
                        // Remove from preferred list if it was there
                        const preferredIndex = preferredActivityList.findIndex(x => x.Id === activityToSave.Id);
                        if (preferredIndex !== -1) {
                            preferredActivityList.splice(preferredIndex, 1);
                        }
                        
                        // Remove from normal list if it was there
                        const normalIndex = activityList.findIndex(x => x.Id === activityToSave.Id);
                        if (normalIndex !== -1) {
                            activityList.splice(normalIndex, 1);
                        }
                    }

                    // Set the final preferred value
                    b.Preferred = finalPreferred;

                    // Add to the correct list based on final preferred status
                    if (b.Preferred) {
                        preferredActivityList.push(b);
                    } else {
                        activityList.push(b);
                    }

                }

                setActivityList(utils.clone(activityList));
                setPreferredActivityList(utils.clone(preferredActivityList));

            }
            else {
                withReactContent(Swal).fire({
                    title: t('oooops', { ns: 'labels' }),
                    icon: "error",
                    text: t('thereAreSomeProblems', { ns: 'labels' }),
                    showConfirmButton: true
                });
            }

        }
        else {
            return {
                success: false,
                message: t('nameIsEmpty', { ns: 'labels' })

            }
        }
    }


    const _drawNewList = (type) => {


        return (<div class="card me-4 newActivityCardGrey" onClick={() => {
            const preferred = (type == 'preferred') ? true : false;

            var newList = {
                ActivityBoardId: id,
                Preferred: preferred,
                LinkedUsers: [currentUser()]
            };

            setCurrentList(newList);

        }}>
            <div className="card-header">
                <i class="fa-solid fa-plus fa me-2  ms-2"></i>
                <h5 className=" col">{t('newActivityList', { ns: 'labels' })}</h5>
            </div>


        </div>)
    }


    const _drawListsType = (type) => {

        let listsToDraw;

        switch (type) {
            case "preferred": {
                listsToDraw = preferredActivityList;
                break;
            }

            default: {
                listsToDraw = activityList;
                break;

            }
        }

        return (<div data-root-node={type} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))" }}>
            {listsToDraw.map(x => {
                return _drawList(x, type);
            })}
            {_drawNewList(type)}
        </div>);

    }

    const _drawActivityList = () => {

        return (<>

            <div className='text-white'>
                <h6 className='text-white'>{t('preferredLists', { ns: 'labels' })}</h6>
                <p>{t('hereYouCanFindYourPreferredLists', { ns: 'labels' })}</p>
                {_drawListsType("preferred")}
            </div>
            <div className='text-white'>
                <h6 className='text-white'>{t('otherLists', { ns: 'labels' })}</h6>
                <p>{t('hereYouCanFindTheOtherLists', { ns: 'labels' })}</p>

                {_drawListsType("normal")}
            </div>
        </>



        )
    }


    const editActivityListModal = () => {

        if (currentList) {
            return (
                <>
                    <div class="modal-backdrop fade show"></div>
                    <div id="activity_list_edit_modal" className="modal fade show" style={{ display: "block" }} >
                        <div className="modal-dialog modal-xl  modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{currentList.Name}</h5>
                                    <button type="button" className="btn-close" aria-label="Close"
                                        onClick={(e) => {
                                            setCurrentList(null);
                                        }}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <label for="item_code" className="form-label">{t('name', { ns: 'labels' })}</label>
                                        <input id="item_code" type="text" className="form-control" value={currentList.Name}
                                            onChange={(e) => {
                                                setCurrentList(prevList => ({
                                                    ...prevList,
                                                    Name: e.target.value,
                                                    __localUpdate: true
                                                }));
                                            }}
                                            placeholder={t('name', { ns: 'labels' })} />
                                    </div>
                                    <div>
                                        <ActivityUserLink
                                            selected={currentList.LinkedUsers ?? []}
                                            value={'Id'}
                                            multiple={true}
                                            dropDownParent={'activity_list_edit_modal'}
                                            textDelegate={(item) => {
                                                return `${item.LastName} ${item.Name} - ${item.EMail}`
                                            }}
                                            remoteSource={async (text) => {
                                                const usersList = await _remoteSearchUsers(text.text, currentList.LinkedUsers);

                                                return usersList;
                                            }}

                                            onChange={(e) => {
                                                setCurrentList(prevList => ({
                                                    ...prevList,
                                                    LinkedUsers: e,
                                                    __localUpdate: true
                                                }));
                                            }}


                                        ></ActivityUserLink>

                                    </div>
                                </div>





                                <div className="modal-footer">
                                                        <button type="button" className="btn btn-secondary"
                        onClick={(e) => {
                            setCurrentList(null);
                        }}
                    >{t('close', { ns: 'labels' })}</button>
                                    <button type="button" onClick={(e) => {
                                        saveList(currentList);
                                        setCurrentList(null);
                                    }}
                                        className="btn btn-primary" disabled={(currentList.Name && currentList.Name != "") ? null : true}>{t('save', { ns: 'labels' })}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else {
            return (null);
        }
    }

    const deleteTask = async (task) => {

        var delete_result = await api.sendMessage("activity/task/deleteTask", {
            user: currentUser(),
            body: { taskId: task.Id }
        });


        if (delete_result.message) {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: delete_result.message,
                showConfirmButton: true
            });
        }
        else {
            withReactContent(Swal).fire({
                title: t('deleted', { ns: 'labels' }),
                icon: "success",
                text: t('taskDeletedCorrectly', { ns: 'labels', taskName: delete_result.deleted_task[0].Name }),
                showConfirmButton: true,
                timer: 1500
            });
            const boardList = activityList.find(x => x.Id == task.ActivityBoardListId);
            boardList.Tasks.splice(boardList.Tasks.findIndex(x => x.Id === task.Id), 1);

            setActivityList(utils.clone(activityList));
        }
    }

    const showDeleteTaskModal = (task) => {
        withReactContent(Swal).fire({
            title: t('areYouSure', { ns: 'labels' }),
            icon: "warning",
            text: t('areYouSureDeleteTask', { ns: 'labels', taskName: task?.Name }),
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('yes', { ns: 'labels' }),
            cancelButtonText: t('no', { ns: 'labels' }),
            confirmButtonColor: "#DD6B55",


        }).then(async (result) => {
            if (result.isConfirmed) {
                deleteTask(task);
                withReactContent(Swal).close();

            }
        });
    }


    const saveTask = async (taskToSave) => {
        withReactContent(Swal).fire({
            title: t('info', { ns: 'labels' }),
            icon: "info",
            text: t('savingData', { ns: 'labels' }),
            showConfirmButton: true,
            timer: 1500
        });

        if (taskToSave.Name && taskToSave.Name != '') {

            var result = await api.sendMessage("activity/task/saveTask", {
                user: currentUser(),
                body: { taskToSave: taskToSave }
            });

            if ((result.tasks?.length + result.links?.length) > 0) {

                for (var task of result.tasks) {

                    let boardList = preferredActivityList.find(x => x.Id == task.ActivityBoardListId);

                    if (boardList) {
                        if (taskToSave.Id) {
                            boardList.Tasks.splice(boardList.Tasks.findIndex(x => x.Id === taskToSave.Id), 1);
                        }
                        boardList.Tasks.push(task);

                        setPreferredActivityList(utils.clone(preferredActivityList));
                    }
                    else {
                        boardList = activityList.find(x => x.Id == task.ActivityBoardListId);

                        if (taskToSave.Id) {
                            boardList.Tasks.splice(boardList.Tasks.findIndex(x => x.Id === taskToSave.Id), 1);
                        }
                        boardList.Tasks.push(task);

                        setActivityList(utils.clone(activityList));
                    }




                }

            }
            else {
                withReactContent(Swal).fire({
                    title: t('oooops', { ns: 'labels' }),
                    icon: "error",
                    text: t('thereAreSomeProblems', { ns: 'labels' }),
                    showConfirmButton: true
                });
            }

        }
        else {
            return {
                success: false,
                message: t('nameIsEmpty', { ns: 'labels' })

            }
        }
    }



    const _remoteSearchUsers = async (text, currentUserLink) => {

        // Require at least 3 characters before searching
        if (!text || text.length < 3) {
            return [];
        }

        const result = await api.sendMessage("activity/board/searchUsers", {
            user: currentUser(),
            body: {
                textToSearch: text
            }

        });

        if (currentUserLink && currentUserLink.length > 0) {
            result.users = result.users.filter(user =>
                !currentUserLink.some(linkedUser => linkedUser.Id === user.Id)
            );
        }


        return result.users;
    }


    const editTaskModal = () => {

        const _localUpdate = () => {
            currentTask.__localUpdate = true;
            // setCurrentList(utils.clone(currentList));
        }

        if (currentTask) {
            return (
                <>
                    <div class="modal-backdrop fade show"></div>
                    <div id="task_edit_modal" className="modal fade show" style={{ display: "block" }} >
                        <div className="modal-dialog modal-xl  modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{currentTask?.Name ?? t('newTask', { ns: 'labels' })}</h5>
                                    <button type="button" className="btn-close" aria-label="Close"
                                        onClick={(e) => {
                                            setCurrentTask(null);
                                        }}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <label for="item_code" className="form-label">{t('name', { ns: 'labels' })}</label>
                                        <input id="item_code" type="text" className="form-control" value={currentTask.Name}
                                            onChange={(e) => {
                                                currentTask.Name = e.target.value;
                                                setCurrentTask(utils.clone(currentTask));
                                                _localUpdate();
                                            }}
                                            placeholder={t('name', { ns: 'labels' })} />
                                    </div>

                                    <div>
                                        <label for="item_code" className="form-label">{t('description', { ns: 'labels' })}</label>
                                        <input id="item_code" type="text" className="form-control" value={currentTask.Description}
                                            onChange={(e) => {
                                                currentTask.Description = e.target.value;
                                                setCurrentTask(utils.clone(currentTask));
                                                _localUpdate();
                                            }}
                                            placeholder={t('description', { ns: 'labels' })} />
                                    </div>

                                    {/* <div>
                                        <ActivityUserLink
                                            selected={currentTask.LinkedUsers ?? []}
                                            value={'Id'}
                                            multiple={true}
                                            dropDownParent ={'task_edit_modal'}
                                            textDelegate={(item) => {
                                                return `${item.LastName} ${item.Name} - ${item.EMail}`
                                            }}
                                            remoteSource={async (text) => {
                                                const usersList = await _remoteSearchUsers(text.text, currentTask.LinkedUsers);

                                                return usersList;
                                            }}

                                            onChange={(e) => {
                                                currentTask.LinkedUsers = e;
                                                // setTask(utils.clone(task));
                                                // SetToSave(true);
                                            }}


                                        ></ActivityUserLink>

                                    </div> */}

                                </div>



                                <div className="modal-footer">
                                                        <button type="button" className="btn btn-secondary"
                        onClick={(e) => {
                            setCurrentTask(null);
                        }}
                    >{t('close', { ns: 'labels' })}</button>
                                    <button type="button" onClick={(e) => {
                                        saveTask(currentTask);
                                        setCurrentTask(null);
                                    }}
                                        className="btn btn-primary" disabled={(currentTask.Name && currentTask.Name != "") ? null : true}>{t('save', { ns: 'labels' })}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else {
            return (null);
        }
    }


    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                </ol>
                <div>


                    <a className="text-primary fs-13" onClick={(e) => {
                        // _saveIndicatorEvaluation();
                    }} role="button" title={t('saveData', { ns: 'labels' })}><i className="fa-solid fa-floppy-disk fa-2x"></i></a>
                </div>
            </div>

            <div style={{
                width: "100%",
                overflow: "scroll"

            }}>
            </div>

            <div className="container-fluid"
                style={{
                    background: `url(${abstractBackground})`, // Uses the imported image
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    borderRadius: '5px',
                    overflowX: 'scroll'

                }}
            >
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card nobackgroundCard" style={{ opacity: '70%' }} >
                            <div className="card-header p-0">
                                <h3 className='ms-2 text-white' >{board?.Name}</h3>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-12">
                        <div className="card nobackgroundCard" style={{ opacity: '70%' }} >
                            <div className="card-body  p-0">
                                <div className="tab-content" id="tabs-content" style={{ padding: 15 }}>
                                    {activityList ? (
                                        <>
                                            {_drawActivityList()}
                                            {editActivityListModal()}
                                            {editTaskModal()}
                                        </>) : <div className="text-center"><img src={waiting} /></div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}


export default ActivityList_Screen